export const fileActions = { ADD: 1, DELETE: 0 }
export const addFile = 'ADD'
export const deleteFile = 'DELETE'
